
import ShowPriceToggleState from "@dana/Store/Data/ShowPrice/ShowPriceToggleState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

import { Draft } from "immer";

const initialState: ShowPriceToggleState = {
    isLoading: false,
    canSeePrice: true,

};

const showPriceToggleStateImmerReducer = createTypedReducerWithImmer(initialState, {
    "ShowPrice/Init": (draft: Draft<ShowPriceToggleState>, action: { isLoading: boolean }) => {
        draft = { ...initialState, isLoading: action.isLoading };
        return draft;
    },
    "ShowPrice/IsLoading": (draft: Draft<ShowPriceToggleState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },
    "ShowPrice/Toggle": (draft: Draft<ShowPriceToggleState>, action: { canSeePrice: boolean }) => {
        draft = { ...draft, canSeePrice: action.canSeePrice };
        return draft;
    },
});

(reducers as any).showPriceToggle = showPriceToggleStateImmerReducer;

type ShowPriceToggleReducers = {
    showPriceToggle: typeof showPriceToggleStateImmerReducer;
};

export type ShowPriceToggleActions = Parameters<ShowPriceToggleReducers[keyof ShowPriceToggleReducers]>[1] | AnyAction;

